/* eslint-disable */
// Innovator
const innovators = ["Albert Einstein", "David Bowie"];

// Entrepreneurial
const entrepreneurs = ["Oprah Winfrey", "Richard Branson"];

// Executional
const executioners = ["Estee Lauder", "J.R.D. Tata"];

// Practical
const practicals = ["George Washington", "Keanu Reeves"];

// Strategist
const strategists = ["Wu Zetian", "Garry Kasparov"];

// Servant
const servants = ["Queen Elizabeth II", "Winston Churchill"];

// Transformational
const transformationals = ["Steve Jobs", "Maya Angelou"];

// Charismatic
const charismatics = ["Dalai Lama", "John Lennon"];

// Professional
const professionals = ["Angela Merkel", "Ranulph Fiennes"];

// Concatenate into single array.
export const jyranians = [
  ...innovators,
  ...entrepreneurs,
  ...executioners,
  ...practicals,
  ...strategists,
  ...servants,
  ...transformationals,
  ...charismatics,
  ...professionals,
];
